import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Popup from '../../../base-components/Popup';
import CustomModal from '../../../base-components/CustomModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faEye, faPen, faTrash, faWarning } from '@fortawesome/free-solid-svg-icons';
import TablePaginationActions from '../../../base-components/TablePaginationActions';
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, IconButton, Menu, MenuItem } from "@mui/material";
import { useFormik } from 'formik';
import Tooltip from '@mui/material/Tooltip';
import { assetSchema } from '../../../schemas';
import dayjs from 'dayjs';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getSessionUser, hasAnyPermission, hasPermission, isDynamicStaffRole } from '../../../utils/roleAccess';
import { PageHeader } from "../../../ui";



const BASE_URL = process.env.REACT_APP_BASE_URL;



 
function Assets() {
    const navigate = useNavigate()
    const [assetToDelete , setAssetToDelete] = useState('')
    const [assetToUpdate , setAssetToUpdate] = useState('')
    const [isAddModalOpen , setIsAddModalOpen] = useState(false)
    const [isViewModalOpen , setIsViewModalOpen] = useState(false)
    const [isDeleteModalOpen , setIsDeleteModalOpen] = useState(false)
    const [isUpdateModalOpen , setIsUpdateModalOpen] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(5);
    // const [page , setPage ] = useState(0)
   
    const [isSuccessAlert , setIsSuccessAlert] = useState(false)
    const [isFaliureAlert , setIsFailureAlert] = useState(false)
    const [successMessage , setSuccessMessage] = useState('')
    const [failureMessage , setFailureMessage] = useState('')
    const [isPopupOpen , setIsPopupOpen] = useState(false)
    const [page, setPage] = React.useState(0);
    const[currentPage,setCurrentPage]=useState(1)
    // const=[locationid,setLocationID]=useState()
    
    const[locations,setLocations]=useState([]);
    const [gymAssets, setGymAssets] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [asset, setAsset] = useState([]);
   const [company_id , setCompanyID] = useState('')
     
     const [location_id , setLocationId] = useState('')
     const [role , setRole] = useState('')
      const [loading , setLoading] = useState(false)
      const [buttonLoading, setButtonLoading] = useState(false);
    
    // Anchor state for the actions menu
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedAssetId, setSelectedAssetId] = useState(null);
    const openAnchor = Boolean(anchorEl);
    const handleClickAnchor = (event, assetId) => {
      setAnchorEl(event.currentTarget);
      setSelectedAssetId(assetId);
    };
    const handleCloseAnchor = () => {
      setAnchorEl(null);
      setSelectedAssetId(null);
    };



 useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
          const session = JSON.parse(sessionStr);
          setRole(session.user.role)
          setCompanyID(session.user.company_id)
          setLocationId(session.user.location_id)
          // console.log("hhhhh",session.user.location_id);
        }
         else {
          navigate('/login');
        }
  },[])


      useEffect(() => {
          if(role) {
              setLoading(true)
              getAllGymAssets()
   
              getLocation()
             
              setTimeout(()=> {
              setLoading(false)
              } , 1000)
          }
  }, [role]);


 
 
  const getAllGymAssets = () => {
 
    if (!role) return;
    setLoading(true)
    let endpoint = '';
    console.log(role);
    if (role === 'SuperAdmin') {
      endpoint = `assets//getAllGymAssets`;
    } else if (role === 'Admin') {
      endpoint = `assets/getGymAssetsByCompanyId/${company_id}`;
    } else if (role === 'ClubAdmin') {
      endpoint = `assets/getGymAssetsByLocationId/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `assets/getGymAssetsByLocationId/${location_id}`;
    }

    fetch(BASE_URL + endpoint)
    .then((response) => response.json())
    .then((data) => {
      setGymAssets(data.gymAssets || []); // Update state with gym assets
      setLoading(false); // Stop loading indicator
    })
    .catch((error) => {
      console.error("Error fetching gym assets:", error); // Log the error
      setLoading(false); // Ensure loading stops even in case of an error
    });
  
  };


  const getGymAssetById = (id) => {
    fetch(BASE_URL + `assets/getGymAssetById/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setSelectedAsset(data.gymAsset);
        setValues({
          asset_name: data.gymAsset.asset_name,
          company_id: data.gymAsset.company_id,
          location_id: data.gymAsset.location_id,
          asset_type: data.gymAsset.asset_type,
          purchase_date: data.gymAsset.purchase_date,
          purchase_price: data.gymAsset.purchase_price,
          vendor: data.gymAsset.vendor,
          warranty_period: data.gymAsset.warranty_period,
          current_condition: data.gymAsset.current_condition,

        })
      })
      .catch((error) => console.error("Error fetching gym asset by ID:", error));
  };

 async function getLocation () {
        if(!role) return;

        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = 'locations/getLocations';
        } else if (role === 'Admin') {
            endpoint = `locations/getLocationsByCompanyID/${company_id}`;
        }
        
        await fetch(BASE_URL + endpoint)
            .then((response) => response.json())
            .then((data) => {
                setLocations(data.locations)
            })
            .catch((error) => {
                console.log(error)
            } );
    }


  const handleAssetadd = async (values, actions) => {
    setButtonLoading(true);
    console.log("Values before save:", values);
    values.company_id = company_id;
    if(role === 'ClubAdmin'){
      values.location_id = location_id;
    } else if (isDynamicStaffRole(role)) {
      values.location_id = location_id;
    }
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };
  
    try {
      const response = await fetch(BASE_URL + `assets/createGymAsset`, requestOptions);
      
      // Log the full response details
      console.log("Response status:", response.status);
      
      if (!response.ok) {
        const errorMessage = await response.text();  
        console.error("Error message from server:", errorMessage);
        setIsFailureAlert(true);
        setFailureMessage(`Failed to add Assets: ${errorMessage}`);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        console.log("Response data:", responseData);
        
        // Check if the response data contains a success message or necessary info
        if (responseData && responseData.gymAsset) {
          setIsAddModalOpen(false);
          actions.resetForm();
          getAllGymAssets();  // Assuming this is a function to fetch updated data
          setIsSuccessAlert(true);
          setSuccessMessage(responseData.message);
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        } else {
          console.error("Unexpected response data:", responseData);
          setIsFailureAlert(true);
          setFailureMessage(responseData.message);
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        }
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to add Assets");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false); // Stop loading indicator
    }
  };

  const handleUpdateAsset = async (values, actions) => {
    setButtonLoading(true);
    values.company_id = company_id;
    if(role === 'ClubAdmin'){
      values.location_id = location_id;
    } else if (isDynamicStaffRole(role)) {
      values.location_id = location_id;
    }
      const requestOptions = {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
      };

      try {
          const response = await fetch(BASE_URL + `assets/updateGymAsset/${assetToUpdate}`, requestOptions);

          console.log('Response status:', response.status);
          if (!response.ok) {
              console.error('Response not ok:', response);
              const responseData = await response.json();
              setIsFailureAlert(true)
              setFailureMessage(responseData.message)
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              }, 5000)
          } else {
              const responseData = await response.json();
              console.log('Response data:', responseData);
              actions.resetForm()
              setIsUpdateModalOpen(false)
              getAllGymAssets()
              setIsSuccessAlert(true)
              setSuccessMessage(responseData.message)
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              }, 5000)
          }
      } catch (error) {
          console.error('Caught error:', error);
          setIsFailureAlert(true)
          setFailureMessage('Failed to Update Assets')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      } finally {
        setButtonLoading(false); // Stop loading indicator
          // setLoading(false);
      }

}

  function deleteAsset () {
    setButtonLoading(true);
      const requestOptions = {
          method: "DELETE",
          headers: {
              "Content-Type": "application/json",
          },
      };
      fetch(BASE_URL + `assets/deleteGymAsset/${assetToDelete}` , requestOptions)
      .then((response) => response.json())
      .then((data) => {
          getAllGymAssets()
          setIsDeleteModalOpen(false)
          setIsSuccessAlert(true)
          setSuccessMessage('Assets deleted Successfully')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      })
      .catch((error) => {
          console.log(error)
          setIsFailureAlert(true)
          setFailureMessage('Failed to delete Assets')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      }).finally(() => {
        setButtonLoading(false); // Stop loading indicator
      });
  }





    function toggleAddModal() {
      setIsAddModalOpen(!isAddModalOpen)
      resetForm()
  }
  function toggleViewModal() {
      setIsViewModalOpen(!isViewModalOpen)
      resetForm()
  }

  function toggleUpdateModal() {
      setIsUpdateModalOpen(!isUpdateModalOpen)
      resetForm()
  }
  function toggleDeleteModal() {
      setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  function showAddModal(id) {
      setIsAddModalOpen(true);
  }
  function showViewModal(id) {
      getGymAssetById(id);
      setIsViewModalOpen(true);
  }
  function showUpdateModal(id) {

      getGymAssetById(id);
      setAssetToUpdate(id);
      setIsUpdateModalOpen(true);
  }
  function showDeleteModal(id) {
    setAssetToDelete(id);
      setIsDeleteModalOpen(true);
  }
  


  const totalPages = Math.ceil(gymAssets.length / rowsPerPage);

  const indexOfLastRow = (page + 1) * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = gymAssets.slice(indexOfFirstRow, indexOfLastRow);

  // Handles both page and rows per page changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Correctly sets the current page
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage); // Updates rows per page
    setPage(0); // Resets to the first page
  };


    const {
      values,
      touched,
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      setValues,
      resetForm,
    } = useFormik({
      enableReinitialize: true, 
      initialValues: {
        company_id: company_id,
        location_id: role === "ClubAdmin" ? location_id :'',
        asset_name: '',
        asset_type: '',
        purchase_date: '',
        purchase_price: '',
        vendor: '',
        warranty_period: '',
        current_condition: '',
      },
      validationSchema: assetSchema(location_id ? true : false), 
      onSubmit: (values, actions) => {
        if (isAddModalOpen) {
          handleAssetadd(values, actions);
        } else if (isUpdateModalOpen) {
          handleUpdateAsset(values, actions);
        }
      },
    });
    console.log("purchase_date:", values.purchase_date);
  return (
    <>
<div className="m-5">
  <PageHeader
    title="Assets"
    actions={
      hasPermission(getSessionUser(), 'assets:create') ? (
          <button className='gx-cta text-sm sm:text-base md:text-lg' onClick={showAddModal}>Add Assets</button>
      ) : null
    }
  />
</div>

{
  loading ? (
    <div className="flex justify-center items-center mt-20 relative">
      {/* SVG Gradient Definition */}
      <svg width="0" height="0">
        <defs>
          <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#D71920" />
            <stop offset="100%" stopColor="#F7931E" />
          </linearGradient>
        </defs>
      </svg>

      {/* Circular Progress with Gradient Stroke */}
      <CircularProgress
        thickness={4}
        size={35}
        sx={{
          'svg circle': {
            stroke: 'url(#gradientColors)', // Apply gradient stroke
          },
        }}
      />
    </div>
  ) : (
    gymAssets && gymAssets?.length !== 0 ? (
      <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn">
        <div className="overflow-x-auto">
          <Table className="min-w-full">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Purchase Date</TableCell>
                <TableCell>Purchase Price</TableCell>
                <TableCell>Vendor</TableCell>
                <TableCell>Warranty Period</TableCell>
                <TableCell>Current Condition</TableCell>
                {hasAnyPermission(getSessionUser(), ['assets:update', 'assets:delete']) && (
                  <TableCell>Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                currentRows.map((asset, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{asset.asset_name}</TableCell>
                    <TableCell>{asset.asset_type}</TableCell>
                    <TableCell>{new Date(asset.purchase_date).toString("dd-MM-yyyy")}</TableCell>
                    <TableCell>{asset.purchase_price}</TableCell>
                    <TableCell>{asset.vendor}</TableCell>
                    <TableCell>{asset.warranty_period}</TableCell>
                    <TableCell>{asset.current_condition}</TableCell>
                    <TableCell>
                      {hasAnyPermission(getSessionUser(), ['assets:update', 'assets:delete']) && (
                        <div className='flex gap-2'>
                          <IconButton onClick={(event) => handleClickAnchor(event, asset._id)}>
                            <MoreVertIcon />
                          </IconButton>
                          <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                            <MenuItem
                              onClick={() => {
                                handleCloseAnchor();
                                showViewModal(selectedAssetId);
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} className='mr-2'/> View
                            </MenuItem>
                            {hasPermission(getSessionUser(), 'assets:update') && (
                            <MenuItem
                              onClick={() => {
                                handleCloseAnchor();
                                showUpdateModal(selectedAssetId);
                              }}
                            >
                              <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                            </MenuItem>
                            )}
                            {hasPermission(getSessionUser(), 'assets:delete') && (
                            <MenuItem
                              onClick={() => {
                                handleCloseAnchor();
                                showDeleteModal(selectedAssetId);
                              }}
                            >
                              <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                            </MenuItem>
                            )}
                          </Menu>
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  colSpan={12}
                  count={gymAssets.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Box>
    ) : (
      <div className='bg-gx-border w-full p-3 mt-10 rounded-lg m-10'>
        <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
      </div>
    )
  )
}

    

    <CustomModal 
  isModal={isAddModalOpen || isUpdateModalOpen} 
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }} 
  size='2xl'
>
  <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>
    {isAddModalOpen ? 'Add Asset' : 'Update Asset'}
  </h1>
  
  <form onSubmit={handleSubmit} className="text-gx-ink-soft m-5" autoComplete="off">
    <div>
      <input type="hidden" name="company_id" value={values.company_id || ''} />
    </div>

    {/* Row 1: Location and Name */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {(role === "SuperAdmin" || role === "Admin") && (
        <div className="w-full">
          <label>Location <span className="text-red-600">*</span></label>
          <select
            name="location_id"
            className={
              "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
              (errors.location_id && touched.location_id ? "border-red-600" : "")
            }
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.location_id}
          >
            <option value="" disabled>Select Location</option>
            {locations?.map((location, index) => (
              <option key={index} value={location._id}>{location.name}</option>
            ))}
          </select>
          {touched.location_id && errors.location_id && (
            <p className="text-red-500 pl-2 italic">{errors.location_id}</p>
          )}
        </div>
      )}

      <div className="w-full">
        <label>Name <span className="text-red-600">*</span></label>
        <input
          type="text"
          name="asset_name"
          placeholder="Enter Name"
          value={values.asset_name}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.asset_name && touched.asset_name ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.asset_name && errors.asset_name && (
          <p className="text-red-500 pl-2 italic">{errors.asset_name}</p>
        )}
      </div>
    </div>

    {/* Row 2: Type and Purchase Date */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>Type <span className='text-red-600'>*</span></label>
        <select
          name="asset_type"
          value={values.asset_type}
          onChange={handleChange}
          onBlur={handleBlur}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.asset_type && touched.asset_type ? "border-red-600" : "")
          }
        >
          <option value="">Select Type</option>
          <option value="Equipment">Equipment</option>
          <option value="Furniture">Furniture</option>
          <option value="Electronics">Electronics</option>
          <option value="Other">Other</option>
        </select>
        {touched.asset_type && errors.asset_type && (
          <p className="text-red-500 pl-2 italic">{errors.asset_type}</p>
        )}
      </div>

      <div className="w-full">
        <label>Purchase Date <span className='text-red-600'>*</span></label>
        <input
          type="date"
          name="purchase_date"
          value={
            values.purchase_date
              ? new Date(values.purchase_date).toString("yyyy-MM-dd") // DateJS formatting
              : ""
          }
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.purchase_date && touched.purchase_date ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.purchase_date && errors.purchase_date && (
          <p className="text-red-500 pl-2 italic">{errors.purchase_date}</p>
        )}
      </div>
    </div>

    {/* Row 3: Purchase Price and Vendor */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>Purchase Price <span className='text-red-600'>*</span></label>
        <input
          type="number"
          name="purchase_price"
          placeholder="Enter Purchase Price"
          value={values.purchase_price}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.purchase_price && touched.purchase_price ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.purchase_price && errors.purchase_price && (
          <p className="text-red-500 pl-2 italic">{errors.purchase_price}</p>
        )}
      </div>

      <div className="w-full">
        <label>Vendor <span className='text-red-600'>*</span></label>
        <input
          type="text"
          name="vendor"
          placeholder="Enter Vendor Name"
          value={values.vendor}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.vendor && touched.vendor ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.vendor && errors.vendor && (
          <p className="text-red-500 pl-2 italic">{errors.vendor}</p>
        )}
      </div>
    </div>

    {/* Row 4: Warranty and Condition */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>Warranty Period <span className='text-red-600'>*</span></label>
        <input
          type="text"
          name="warranty_period"
          placeholder="Enter Warranty Period (in months)"
          value={values.warranty_period}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.warranty_period && touched.warranty_period ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.warranty_period && errors.warranty_period && (
          <p className="text-red-500 pl-2 italic">{errors.warranty_period}</p>
        )}
      </div>

      <div className="w-full">
        <label>Condition <span className='text-red-600'>*</span></label>
        <select
          name="current_condition"
          value={values.current_condition}
          onChange={handleChange}
          onBlur={handleBlur}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.current_condition && touched.current_condition ? "border-red-600" : "")
          }
        >
          <option value="">Select Condition</option>
          <option value="New">New</option>
          <option value="Good">Good</option>
          <option value="Average">Average</option>
          <option value="Poor">Poor</option>
          <option value="Broken">Broken</option>
        </select>
        {touched.current_condition && errors.current_condition && (
          <p className="text-red-500 pl-2 italic">{errors.current_condition}</p>
        )}
      </div>
    </div>

    {/* Submit Button */}
    <div className="flex justify-end items-center pt-3 mt-3 border-t">
      <button
        type="submit"
        className={`bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
        disabled={buttonLoading}
      >
        {buttonLoading ? "Submitting..." : "Submit"}
        {buttonLoading && (
          <CircularProgress
            size={20}
            className="ml-2 mt-1"
            sx={{ color: "white" }}
          />
        )}
      </button>
    </div>
  </form>
</CustomModal>



<CustomModal isModal={isViewModalOpen} handleModal={toggleViewModal} size='2xl'>
  
    <div className="overflow-x-auto">
      <Tooltip title="" placement="bottom">
        <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
          View Assets
        </h1>
        <div className="m-5">
          <Box>
            <Table className="min-w-full">
              <TableBody>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Location</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.location_id}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Name</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.asset_name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Purchase Price</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.purchase_price}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Vendor</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.vendor}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Purchase Date</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">
                      {selectedAsset?.purchase_date
                      ? dayjs(selectedAsset?.purchase_date).format("DD/MM/YYYY")  //new Date(selectedAsset.purchase_date).toString("dd/MM/yyyy")
                      : ''}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Warranty Period</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.warranty_period}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Type</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.asset_type}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-2 py-3 sm:px-4">Condition</TableCell>
                  <TableCell className="px-2 py-3 sm:px-4">{selectedAsset?.current_condition}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </div>
      </Tooltip>
    </div>
  
</CustomModal>





  <CustomModal isModal={isDeleteModalOpen} handleModal={toggleDeleteModal} size='md'>
    <div className='m-5'>
        <h2 className="text-xl font-medium">Delete Asset?</h2>
        <p className="text-gx-ink-soft mt-3">Are you sure you want to delete this asset?</p>
        <button className={`bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`} onClick={deleteAsset} disabled={buttonLoading}>
          {buttonLoading ? "Deleting..." : "Delete"}
          {buttonLoading && (
            <CircularProgress
              size={20}
              className="ml-2 mt-1"
              sx={{ color: "white" }}
            />
          )}
        </button>
    </div>
  </CustomModal>
{
    isPopupOpen && (
        <Popup 
            onClose={() => setIsPopupOpen(false)}
            alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
            message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
        />
    )
  }

      
    </>
  )
}

export default Assets